/* eslint-disable camelcase */
import axios from 'axios';
import { WEB } from '../constants/constants';

export interface IGetOTPResult {
  otpSent: boolean;
  maxOtpRetriesExceeded: boolean;
  existing: boolean;
  eligible: boolean;
  scoreUser: boolean;
}
interface IOTP {
  mobileNumber: string;
  whatsappConsent: boolean;
  data_attributes: string;
  partner_name: string;
}

export const getOTP = async (mobiledetail: IOTP) => {
  const {
    mobileNumber,
    whatsappConsent,
    data_attributes,
    partner_name,
  } = mobiledetail;
  const response = await axios.post<IGetOTPResult>(
    `${process.env.REACT_APP_BFF_URL}/open/v1/web/otp/generate`,
    {
      mobile: mobileNumber,
      deviceType: WEB,
      whatsappConsent,
    },
    {
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
        'Content-Type': 'application/json',
        data_attributes,
        partner_name,
      },
    },
  );

  return response;
};
